/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReferenceDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function ReferenceDate({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/ReferenceDate",
  isInvalid,
  onChange,
  isSubmitting
  
}) {
let reportFilterValuesReferenceDateValueData = fromData.useDataFormat({ viewPath,
context: 'report',
path: 'filter_values.reference_date',
format: fromFormat.dateISOIn,
})
let reportFilterValuesReferenceDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'report',
path: 'filter_values.reference_date',
validate: fromValidate.date,
})
let reportFilterValuesReferenceDateChangeData = fromData.useDataChange({ viewPath,
context: 'report',
path: 'filter_values.reference_date',
formatOut: fromFormat.dateShortOutTempFixForMaskedInput,
})
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexGrow={0}
 marginTop={dtSpaceS}
 required={true}
 type="date"
 marginTop={dtSpaceS}
 data="report.filter_values.reference_date"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOutTempFixForMaskedInput"
 validate="/Data/validate.js date"
 invalid={!reportFilterValuesReferenceDateIsValidData}
 value={reportFilterValuesReferenceDateValueData}
 onChange={reportFilterValuesReferenceDateChangeData}
 data="selected"
 disabled={selectedIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Statement date"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
 yearPicker={true}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}